export default __webpack_public_path__ + "static/media/151-maps-and-flags-1.fef2016c.png";